<script setup>
import { defineProps } from 'vue';

defineProps({
    text: {
        type: String,
        required: true
    }
});
</script>

<template>
    <div class="relative flex items-center group">
        <slot></slot>
        <div
            class="tooltip absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-3 py-1 bg-gray-500 text-white rounded-lg invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 whitespace-nowrap ease-in-out opacity-0 hover:opacity-100"
        >
            {{ text }}
        </div>
    </div>
</template>
